// Function to show the loader message
function showLoader() {
    // Select the cart area where the loader message should be shown
    const cartDetails = document.querySelector('td.cart-item__details dl');
    if (!cartDetails) {
        console.warn("Cart area not found, unable to show the loader.");
        return;
    }

    // Check if the loader message already exists
    if (document.getElementById('loaderMessage')) {
        console.log("Loader message already exists, skipping creation.");
        return;
    }

    // Create the loader message container
    const loaderMessage = document.createElement('div');
    loaderMessage.id = 'loaderMessage';
    loaderMessage.innerText = 'Fetching data, please wait...';
    loaderMessage.style.display = 'inline-block';
    loaderMessage.style.backgroundColor = 'white';
    loaderMessage.style.padding = '10px';
    loaderMessage.style.borderRadius = '8px';
    loaderMessage.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';
    loaderMessage.style.fontFamily = 'Arial, sans-serif';
    loaderMessage.style.textAlign = 'center';
    loaderMessage.style.marginTop = '10px';
}

// Function to hide the loader message
function hideLoader() {
    const loaderMessage = document.getElementById('loaderMessage');
    if (loaderMessage) {
        loaderMessage.remove(); // Removes the message from the DOM
    } else {
        console.warn("Loader message not found, nothing to hide.");
    }
}

// Function to show a notification message
function showNotification(message) {
    const notification = document.createElement('div');
    notification.innerText = message;
    notification.style.position = 'fixed';
    notification.style.bottom = '20px';
    notification.style.left = '50%';
    notification.style.transform = 'translateX(-50%)';
    notification.style.backgroundColor = '#f8d7da';
    notification.style.color = '#721c24';
    notification.style.padding = '10px';
    notification.style.border = '1px solid #f5c6cb';
    notification.style.borderRadius = '5px';
    notification.style.zIndex = '9999';
    notification.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';
    document.body.appendChild(notification);

    setTimeout(() => {
        notification.remove(); // Remove the notification after 5 seconds
    }, 5000);
}

var processedProducts = {};
const ondcProductMap = {}; 

document.addEventListener('click', async function (event) {
  // Check if the clicked element is the remove button (customize selector as needed)
  console.log('event.target',event.target)
  if (event.target.matches('.cart-remove-button')) {
      const currentRes = await fetch("/cart.json");
      if (!currentRes.ok) {
        throw new Error("Failed to fetch cart data.");
      }
      const currentCart = await currentRes.json();

    currentCart.items.forEach(item => {
      const key = item.key; 
      // console.log('key*********',key);
      // console.log('processedProducts******',processedProducts);
      // Remove the product from processedProducts if it no longer exists in the cart
      if (!currentCart.items.some(cartItem => cartItem.key === key)) 
        delete processedProducts[key];
      //   console.log(`Removed ${key} from processedProducts.`);
      });

    // Optionally, refresh the cart drawer or update UI here
    await refreshCartDrawer();
  }
});

const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

addToCartForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    
      // Prevent normal submission
      event.preventDefault();

      // Check if the product is Ondc.
      let isOndcProduct = form?.getAttribute("data-is-ondc");
      
       if (!isOndcProduct) {
        const hiddenInput = document.getElementById('isOndcProduct').value;
        if (hiddenInput) {
          isOndcProduct = hiddenInput;
        }
      }

    // Get the product's variant ID (required to track in the cart)
    const variantId = form.querySelector('[name="id"]').value;

    // Store the ONDC status for this variant in the ondcProductMap
    ondcProductMap[variantId] = isOndcProduct;

      if (isOndcProduct === 'true') {
        
      // Submit the form with AJAX
      const formData = new FormData(form);
      zipcode = document.querySelector("#cart-zipcode").value;
      console.log("Zipcode to be sent in note is = " + zipcode);
      formData.append('note', zipcode.trim());

      await fetch("/cart/add", {
        method: "POST",
        body: formData,
      });

      // Get the updated cart object
      const res = await fetch("/cart.json");
      if (!res.ok) {
        throw new Error("Failed to fetch cart data.");
      }
      const cart = await res.json();
      console.log('cart****',cart);
        
       console.log("****** START ADD ZIP CODE **********")
      for (let i =0; i < cart.items.length; i++) {
        await addZipcode(i);
      }
      console.log('Added after Zipcode',cart)
      console.log("****** COMPLTETED ADD ZIP CODE **********")
        
      // Process each item in the cart
      for (const item of cart.items) {
        const { key, quantity } = item;
        const isOndc = ondcProductMap[item.variant_id] || false; // Default to `false` if not found
        
      if (isOndc === "true") {
        // Skip if the product's quantity is already processed and unchanged
        if (processedProducts[key]?.quantity === quantity) {
          console.log(`Skipping product: ${key}, quantity unchanged (${quantity})`);
          continue;
        }
      
        // Log debug info if this is a new product or quantity has changed
        if (!processedProducts[key]) {
          console.log(`Processing product for the first time: ${key}`);
        } else {
          console.log(`Quantity updated for product key: ${key}, old: ${processedProducts[key]?.quantity}, new: ${quantity}`);
        }
      
        // Fetch meta fields for the product
        const fetchedData = await fetchMetaFields(item.product_id, cart.token.split("?")[0], key);
        console.log("Cart Token is == " + cart.token.split("?")[0]);
        if (fetchedData) {

      const updatedCartResponse = await addProperties(cart.token.split("?")[0], item.variant_id, fetchedData, cart.items);

      // Find the updated item in the returned cart.items array
      const updatedItem = updatedCartResponse.items.find(
        (cartItem) => cartItem.variant_id === item.variant_id && cartItem.quantity === quantity
      );

      if (updatedItem) {
        const newKey = updatedItem.key;

        // Update processedProducts with the new key
        if (newKey !== key) {
          console.log(`Key updated from ${key} to ${newKey}`);
          processedProducts[newKey] = { quantity }; // Use new key for processed products
          delete processedProducts[key]; // Remove old key from processedProducts
        } else {
          // If keys are unchanged, just update quantity
          processedProducts[key] = { quantity };
        }

        console.log(`Updated processedProducts for ${newKey}:`, processedProducts[newKey]);
      } else {
        console.warn(`Could not find updated item for variant_id: ${item.variant_id}`);
      }
        } else {
          console.warn(`No metadata found for product key: ${key}`);
        }
      } else {
        console.log("Skipping non-ONDC product:", item);
      }      
    }
      
      // Refresh the cart drawer
      await refreshCartDrawer();
      console.log("All operations completed successfully for new or updated items in the cart.");
      } else {
            console.log('Product is not ONDC, skipping submission.');
      }
  });
});

async function fetchMetaFields(productId, token, variantId) {
    showLoader(); // Display loader at the start
    const url = Shopify.shop;
    const api = "https://live.eazehub.com/live/strsvc/shopify/quote-breakup";
    const maxAttempts = 4;
    const delay = 4000; // 5 seconds
    const zipcode = document.querySelector("#cart-zipcode").value;
    const userLatitude = localStorage.getItem('user_latitude');
    const userLongitude = localStorage.getItem('user_longitude');


    let attempts = 0;
    while (attempts < maxAttempts) {
        try {
            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    product_id: productId,
                    url: url,
                    cart_token: token,
                    zipcode: zipcode,
                    gps_details: {
                      latitude: userLatitude,
                      longitude: userLongitude
                    }
                }),
            });

            const data = await response.json();
            const status = data?.message?.data?.status;
            lastMsg = data?.message?.data?.msg || "Seller has not responded."; 
            console.log('status:', status);
            console.log('data res:', data);
    
            if (status === "3010001") {
                const cartButton = document.querySelector('.cart__ctas');
                const variantId = '49769538683160';
                 if (variantId) {
                    await removeProductFromCart(variantId); 
                }
                if (cartButton) {
                  cartButton.style.display = 'block';
              }
                hideLoader();
                console.log("******************************** SUCCESS *********************************");
                return data;
            } else if (status === "3010003") {
                 const cartButton = document.querySelector('.cart__ctas');
                  if (cartButton) {
                      cartButton.style.display = 'none';
                  }
                attempts++;
                console.log(`Status 3010003 received. Attempt ${attempts}. Retrying in ${delay / 1000} seconds...`);
                await new Promise((resolve) => setTimeout(resolve, delay));
            } else if (status === "3010004") {
              const cartButton = document.querySelector('.cart__ctas');
                    if (cartButton) {
                        cartButton.style.display = 'none';
                    }
                //showNotification("Location is not serviceable");
                showNotification(lastMsg); 
                await removeProductFromCart(variantId);
                await new Promise((resolve) => setTimeout(resolve, delay));
            } else if (status === "3010002") {
                 const cartButton = document.querySelector('.cart__ctas');
                    if (cartButton) {
                        cartButton.style.display = 'none';
                    }
                hideLoader();
                //showNotification("The Product is no longer available.");
                showNotification(lastMsg); 
                await removeProductFromCart(variantId);
                throw new Error(`The Product is no longer available: ${status}`);
            } else {
                console.log('No status found');
              const cartButton = document.querySelector('.cart__ctas');
                    if (cartButton) {
                        cartButton.style.display = 'none';
                    }
                await removeProductFromCart(variantId);
                throw new Error("The Product is no longer available");
            }
        } catch (error) {
            hideLoader();
            // showNotification("Item not in stock");
            console.log('error:', error);
            throw error; 
        }
    }

    hideLoader();
    // showNotification(lastMsg); 
    await removeProductFromCart(variantId);
    // throw new Error(lastMsg);
}

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", async function (event) {
        if (event.target.matches('.quantity__button[name="plus"]')) {
            console.log("Plus button clicked! Calling API...");

            // Find the closest cart item container
            const cartItem = event.target.closest(".cart-item");

            if (!cartItem) {
                console.error("Cart item not found!");
                return;
            }

            // Get product details from data attributes (Ensure these attributes are available in HTML)
            const productId = document.querySelector("td.cart-item__details input[name='product_id']").value;
            const inputElement = document.querySelector('.quantity__input');
            const variantId = inputElement.getAttribute('data-quantity-variant-id');

            if (!productId || !variantId) {
                console.error("Product ID or Variant ID missing in the cart item data.");
            }

            console.log("Product ID:", typeof(productId), productId);
            console.log("Variant ID:", variantId);

            // Fetch the cart token dynamically
            let token = await getCartToken();

            // Slice the cart token to remove anything after '?'
            token = token ? token.split("?")[0] : null;

            console.log("Cart Token:", token);

            if (token && productId && variantId) {
                try {
                    const response = await fetchMetaFields(Number(productId), token, variantId);
                    console.log("API Response:", response);
                } catch (error) {
                    console.error("Error calling fetchMetaFields:", error);
                }
            } else {
                console.error("Missing product ID, cart token, or variant ID.");
            }
        }
    });
});

// Function to fetch cart token dynamically
async function getCartToken() {
    try {
        const response = await fetch("/cart.js");
        const cart = await response.json();
        return cart.token || null;
    } catch (error) {
        console.error("Error fetching cart token:", error);
        return null;
    }
}

async function setNotes(){
    zipcode = document.querySelector("#cart-zipcode").value;
    console.log("Zipcode Value = " + zipcode);
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            note: zipcode.trim()
        })
    });
    return result.json();
}

async function addZipcode(index){
  console.log("Add Zipcode for index " + index);
  let zipData = {
    "Deliver to" : document.querySelector("#cart-zipcode").value
  }

  console.log("Zipcode ===" + JSON.stringify(zipData));
  const updateApi = `/cart/change.js`;
  const formData = { 
    'properties': zipData,
    'line': index + 1,
  }

  console.log("FormData ===" + JSON.stringify(formData));
  try {
    const response = await fetch(updateApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (!response.ok) {
      console.log('Pincode set failed...');
    }

    const data = await response.json();
    console.log('Response data:', data);
    return data;
  } catch (error) {
     console.log('Pincode is not set');
  }  
}

async function addProperties(token, cartVariantId,properties,cartItems) {
  console.log('cartItems',cartItems)
    // Find the correct line number for the given lineItemId
  const lineIndex = cartItems.findIndex(item => item.variant_id === cartVariantId);
  console.log('index', lineIndex)
  if (lineIndex === -1) {
    console.error(`variant_id not found in cart.`);
    return;
  }
  const lineNumber = lineIndex + 1;
  const productQuantity = cartItems[lineIndex]?.quantity;
  console.log('productQuantity',productQuantity)
  const allowedTitles = ["Packing charges", "Delivery charges", "Tax","Convenience Fee"];

  const items = properties.message.data.quoteBreakup
  .filter((item) => allowedTitles.includes(item.title)) // Filter to keep only allowed titles
  .reduce((acc, item) => {
    acc[item.title] = `₹${item.price.value}`;
    return acc;
  }, {});
  items.sku = token + "|" + cartVariantId;
  const updateApi = `/cart/change.js`;
  const formData = { 
  'line':lineNumber,
  //'properties': items,
  'quantity':productQuantity,
}
 try {
    const response = await fetch(updateApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
      console.log('data is fetching value');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating product in cart:', error);
   console.log('data not fetching value');
  }
}


async function refreshCartDrawer() {
  try {
    // Fetch updated cart drawer HTML
    const response = await fetch('/?section_id=cart-drawer');
    if (!response.ok) {
      throw new Error(`Failed to fetch cart drawer: ${response.statusText}`);
    }

    const cartHtml = await response.text();

    // Create a temporary container to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartHtml;

    const updatedCartDrawer = tempDiv.querySelector('cart-drawer'); // Adjust if your theme uses a different tag
    if (updatedCartDrawer) {
      const currentCartDrawer = document.querySelector('cart-drawer'); // Adjust selector if needed
      if (currentCartDrawer) {
        // Replace the inner content of the cart-drawer
        currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;
        // Handle the "is-empty" class if the cart is empty
        if (updatedCartDrawer.classList.contains('is-empty')) {
          currentCartDrawer.classList.add('is-empty');
        } else {
          currentCartDrawer.classList.remove('is-empty');
        }
      }
    } else {
      console.error('Cart drawer element not found in the response.');
    }
  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
  }
}

async function removeProductFromCart(lineItemId) {
  console.log("lineItemId", lineItemId);
  const vid = lineItemId.split(":");
  console.log("VID ", vid[0]);
  const api = `/cart/change.js`;
  try {
    const response = await fetch(api, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        id: vid[0], // Pass the variant ID or `variantId:cartToken`
        quantity: 0, // Set quantity to 0 to remove the item
      }).toString(),
    });

    if (!response.ok) {
      throw new Error(
        `Failed to remove product from cart: ${response.statusText}`
      );
    }
    await refreshCartDrawer();
    console.log("Product removed successfully from the cart.");
  } catch (error) {
    console.error("Error removing product from cart:", error);
  }
}
